import * as React from "react";
import * as ReactQuill from "react-quill";
import { Constants, ProjectViews } from "../../abstract";
// tslint:disable-next-line:ordered-imports
import { Views } from "../../../abstract";

interface IDashboardUspAddEditViewProps extends Interfaces.IViewProps {
  onSave: () => void;
}

class DashboardUspAddEditView<P, S> extends ProjectViews.CommonView<
  P & IDashboardUspAddEditViewProps,
  S
> {
  constructor(props: any) {
    super(props);
  }

  public validateForm() {
    const { onSave } = this.props;
    const { model } = this.state;
    if (model) {
      if (model["name"]) {
        if (model["title"].ru && model["title"].en) {
          if (model["subtitle"].ru && model["subtitle"].en) {
            if (model["image"].ru) {
              if (model["image"].alt.ru && model["image"].alt.en) {
                onSave();
              } else {
                this.setState({
                  error: "Заполните мета-описание изображения!",
                } as any);
              }
            } else {
              this.setState({ error: "Добавьте изображение!" } as any);
            }
          } else {
            this.setState({
              error: "Заполните подзаголовок УТП на обоих языках!",
            } as any);
          }
        } else {
          this.setState({
            error: "Заполните загловок УТП на обоих языках!",
          } as any);
        }
      } else {
        this.setState({ error: "Заполните наименование УТП!" } as any);
      }
    }
  }

  public renderFullWidthSide() {
    const { model, languageTabValue } = this.state;
    return (
      <React.Fragment>
        <Views.TextField
          floatingLabelText="Наименование"
          fullWidth={true}
          data-field-type="nml"
          name="name"
          value={model && model["name"] ? model["name"] : ""}
          onChange={(e) => this.onTextChange(e)}
        />
        <Views.TextField
          floatingLabelText="Заголовок"
          fullWidth={true}
          name="title"
          value={
            (model && model["title"] && model["title"][languageTabValue]) || ""
          }
          onChange={(e) => this.onTextChange(e)}
        />
        <Views.TextField
          floatingLabelText="Подзаголовок"
          fullWidth={true}
          multiLine={true}
        //   maxlength="250"
          name="subtitle"
          value={
            (model &&
              model["subtitle"] &&
              model["subtitle"][languageTabValue]) ||
            ""
          }
          onChange={(e) => this.onTextChange(e)}
        />
        <Views.Dropzone
          file={model && model["image"][languageTabValue]}
          onDrop={(files: any) => this.onDropImage(files)}
          multiple={false}
          onClear={() => this.onDropImage()}
          placeholder="УТП"
          accept="image/*"
        />
        <Views.TextField
          floatingLabelText="Мета-описание изображения"
          fullWidth={true}
          name="image alt"
          value={(model && model["image"]["alt"][languageTabValue]) || ""}
          onChange={(e) => this.onTextChange(e)}
        />
        <ReactQuill
          modules={{
            syntax: true,
            clipboard: {
              matchVisual: false,
            },
            toolbar: Constants.QuillEditorConstants.toolbarOptions,
          }}
          placeholder="Контент УТП"
          onChange={(v) => this.onTextChange(v, "content")}
          className="editor-view"
          value={model ? model["content"][languageTabValue] || "" : ""}
        />
      </React.Fragment>
    );
  }
}

export default DashboardUspAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/usp/addedit/UspAddEditView.tsx